import { TDrugSlot } from "app/_modules/core/types";
import { TActivityBucket } from "app/_modules/core/utils/activityCard";
import { getSlotRangeLabel } from "app/_modules/core/utils/drugIntake";

export const activitySuccessContent = ({
    administered,
    activityType,
    actualWindow,
    prescribedWindow,
}: {
    administered: boolean,
    activityType?: 'drug' | 'questionnaire' | 'measurement',
    actualWindow?: TDrugSlot,
    prescribedWindow?: TActivityBucket,
}) => {
    if (activityType === 'questionnaire') {
        return {
            title: "screens.activities.activityCompleted.title",
            description: "screens.activities.activityCompleted.description"
        }
    }

    if (activityType === 'measurement') {
        return {
            title: "screens.activities.activityCompleted.title",
            description: "screens.activities.activityCompleted.description"
        }
    }

    if (activityType === 'drug') {
        if (administered === false) {
            return {
                title: "screens.activities.drugsIntake.informationSentToDoctor",
            }
        }

        const declaredWindow = actualWindow ?? (prescribedWindow !== 'daily' ? prescribedWindow : undefined);

        if (!actualWindow) {
            return {
                title: "screens.activities.drugsIntake.inSlot.title",
                description: declaredWindow ? `screens.activities.drugsIntake.window.${declaredWindow}` : undefined,
                confirmButtonKey: "screens.activities.drugsIntake.confirmButton",
            }
        }

        const isOutOfSlot = actualWindow !== prescribedWindow;

        return {
            title: "screens.activities.drugsIntake.registered.title",
            description: `screens.activities.drugsIntake.window.${actualWindow}`,
            showInfobox: isOutOfSlot,
            infoboxPrescribedRange: prescribedWindow && prescribedWindow !== 'daily' ? getSlotRangeLabel(prescribedWindow) : undefined,
            confirmButtonKey: "screens.activities.drugsIntake.confirmButton",
        }
    }

    switch (administered) {
        case true:
            return {
                title: "screens.activities.drugsIntake.activityCompleted.title",
                description: "screens.activities.drugsIntake.activityCompleted.description"
            }
        case false:
            return {
                title: "screens.activities.drugsIntake.informationSentToDoctor",
            }
        default:
            return {
                title: "screens.activities.drugsIntake.activityCompleted.title",
                description: "screens.activities.drugsIntake.activityCompleted.description"

            }
    }
}